import { render, staticRenderFns } from "./LayoutWidgets.vue?vue&type=template&id=1f21ba92&"
import script from "./LayoutWidgets.vue?vue&type=script&lang=js&"
export * from "./LayoutWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f21ba92')) {
      api.createRecord('1f21ba92', component.options)
    } else {
      api.reload('1f21ba92', component.options)
    }
    module.hot.accept("./LayoutWidgets.vue?vue&type=template&id=1f21ba92&", function () {
      api.rerender('1f21ba92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Home/LayoutWidgets.vue"
export default component.exports